export default {
  viewCustomer: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005FE","查看客户") /* "查看客户" */,
  referCaption: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005FF","客户") /* "客户" */
};
